module.exports = __webpack_public_path__ + "img/tbbf.1f4d1e1.png";